import { Paper, Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { DashboardCardProps } from './DashboardCard.types'

export const DashboardCardView = ({
  fullHeight,
  title,
  children,
  onClick,
}: DashboardCardProps) => {
  const theme = useTheme()
  return (
    <Paper
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        padding: theme.spacing(2),
        height: fullHeight ? '100%' : 'auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Box sx={{ marginBottom: theme.spacing(1) }}>
          <Typography variant="h3">{title}</Typography>
        </Box>
        <Box>{children}</Box>
      </Box>
    </Paper>
  )
}
